import { LocDefs, LocMap } from '@cm/core/localization';
import {
	ncarbSchedulingPathStart,
	ncarbSchedulingSharedProperties,
} from '../ncarb-scheduling/ncarb-scheduling.locs';

export type SPCandidateHistorySchedulingNcarbAuthsLocNames =
	| 'SPCandidateHistorySchedulingNcarbAuthsSectionTitle'
	| 'SPCandidateHistorySchedulingNcarbAuthsColumnName'
	| 'SPCandidateHistorySchedulingNcarbAuthsColumnEligibilityId'
	| 'SPCandidateHistorySchedulingNcarbAuthsColumnStartDate'
	| 'SPCandidateHistorySchedulingNcarbAuthsColumnEndDate'
	| 'SPCandidateHistorySchedulingNcarbAuthsExportFilename'
	| 'SPCandidateHistorySchedulingNcarbAuthsAddButton'
	| 'SPCandidateHistorySchedulingNcarbAuthsEditButton'
	| 'SPCandidateHistorySchedulingNcarbAuthsRevokeButton'
	| 'SPCandidateHistorySchedulingNcarbAuthsUnrevokeButton';

export const spCandidateHistorySchedulingNcarbAuthsLocs: LocDefs<SPCandidateHistorySchedulingNcarbAuthsLocNames> =
	{
		SPCandidateHistorySchedulingNcarbAuthsSectionTitle: {
			defaultValue: 'Exam Authorizations',
			description: 'Section title for the exam authorizations section.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|Section Title`,
			displayType: 'Title',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthsColumnName: {
			defaultValue: 'Exam',
			description: 'Column name for the exam name column.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|Exam Name Column`,
			displayType: 'Label',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthsColumnEligibilityId: {
			defaultValue: 'Eligibility ID Number',
			description: 'Column name for the eligibility ID column.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|Eligibility ID Column`,
			displayType: 'Label',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthsColumnStartDate: {
			defaultValue: 'Start Date',
			description: 'Column name for the start date column.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|Start Date Column`,
			displayType: 'Label',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthsColumnEndDate: {
			defaultValue: 'End Date',
			description: 'Column name for the end date column.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|End Date Column`,
			displayType: 'Label',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthsExportFilename: {
			defaultValue: 'Exam Authorizations',
			description: 'Export filename for the exam authorizations.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|Export Filename`,
			displayType: 'Title',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthsAddButton: {
			defaultValue: 'Add',
			description: 'Add button for the exam authorizations.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|Add Button`,
			displayType: 'Button',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthsEditButton: {
			defaultValue: 'Edit',
			description: 'Edit button for the exam authorizations.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|Edit Button`,
			displayType: 'Button',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthsRevokeButton: {
			defaultValue: 'Revoke',
			description: 'Revoke button for the exam authorizations.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|Revoke Button`,
			displayType: 'Button',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthsUnrevokeButton: {
			defaultValue: 'Un-Revoke',
			description: 'Un-Revoke button for the exam authorizations.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|Un-Revoke Button`,
			displayType: 'Button',
			...ncarbSchedulingSharedProperties,
		},
	};

export type SPCandidateHistorySchedulingNcarbAuthsLocType =
	LocMap<SPCandidateHistorySchedulingNcarbAuthsLocNames>;
